// Figma: RGM Landing Page > Navbar V2 rail > global filter
const Funnel = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.13 4.38h13.74l-5.4 6.4v5.34l-2.94-1.6v-3.74l-5.4-6.4Z"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Funnel;
